import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import useEventInfo from './use-event-info';
import EventDescription from './event-description';

export const EventsInfo = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const events = useEventInfo();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h3">
        {t(
          'v2.dashboard.section_eventList_label_subtitle_workshopsAndWebinars',
        )}
      </Typography>

      {events.map((item) => (
        <EventDescription {...item} />
      ))}
    </Box>
  );
};

export default EventsInfo;
